// function Footer() {
//   return (
//     <div className="">
//       <div className="">
//         <div>&nbsp;</div>
//         <div className="w-[88%] sm:w-[73%] mt-[76px] sm:mt-[162px] grid grid-cols-2 gap-y-[50px] sm:gap-0 sm:grid-cols-4 justify-between mx-auto">
//           <div className="">
//             <div className=" text-white font-bold text-[14px] sm:text-[16px]">
//               Solutions
//             </div>
//             <div className="text-white mt-2 sm:mt-4 gap-[3px] sm:gap-[6px] opacity-50 text-[14px] sm:text-[16px] flex flex-col">
//               <a href="/hoots">Hoots</a>
//               <a href="/kuwago">Kuwago</a>

//               <a href="/pique">Pique</a>
//               <a href="/owltalk">Owltalk</a>
//               <a href="/perch">Perch</a>
//             </div>
//           </div>

//           <div className="">
//             <div className=" text-white font-bold text-[14px] sm:text-[16px]">
//               Services
//             </div>
//             <div className="text-white mt-2 sm:mt-4 gap-[3px] sm:gap-[6px] opacity-50 text-[14px] sm:text-[16px] flex flex-col">
//               <a href="/generative-ai">Generative AI</a>
//               <a href="/analytics-and-ml">Machine Learning</a>
//               <a href="/data-platform">Data Platforms</a>
//               <a href="/customer-experience">Customer Engagement</a>
//             </div>
//           </div>

//           <div className="">
//             <div className=" text-white font-bold text-[14px] sm:text-[16px]">
//               About
//             </div>
//             <div className="text-white mt-2 sm:mt-4 gap-[3px] sm:gap-[6px] opacity-50 text-[14px] sm:text-[16px] flex flex-col">
//               <a href="/story">Company</a>
//               <a href="/story">Team</a>
//               <a href="/story">Careers</a>
//               <a href="/story">Blog</a>
//             </div>
//           </div>

//           <div className="">
//             <div className=" text-white font-bold text-[14px] sm:text-[16px]">
//               Contact
//             </div>
//             <div className="text-white mt-2 sm:mt-4 gap-[3px] sm:gap-[6px] opacity-50 text-[14px] sm:text-[16px] flex flex-col">
//               <a href="onebyzero.ai">Email</a>
//               <a href="/">Facebook</a>
//               <a href="/">Twitter</a>
//               <a href="/">Instagram</a>
//             </div>
//           </div>
//         </div>

//         <div className="mt-[93px] sm:mt-[186px] text-white opacity-50 text-center mb-1 sm:mb-2 text-[14px] sm:text-[16px]">
//           © 2024 OneByZero Pte.
//         </div>

//         <div className="invisible">&nsbp;</div>
//       </div>
//     </div>
//   );
// }

const Box = ({ title, dataList }) => {
  const list = dataList.map((item, index) => {
    return (
      <a
        href={item.link}
        key={index}
        className="group transition-all duration-200 hover:opacity-80"
        target={item.target}
      >
        <div className="leading-[140%] capitalize text-[14px] md:text-[16px] tracking-[-0.35px] RoobertRegular text-[#FFF] group-hover:opacity-100 transition-opacity duration-200">
          {item.text}
        </div>
      </a>
    );
  });

  return (
    <div className="flex flex-col items-start shrink-0 gap-6">
      <div className="text-[16px] md:text-[18px] text-[#FFF] leading-[120%] tracking-[-0.4px] RoobertSemiBold">
        {title}
      </div>
      <div className="text-[14px] md:text-[16px] flex flex-col items-start gap-3">
        {list}
      </div>
    </div>
  );
};

function NewFooter() {
  return (
    <div
      className="relative bg-cover bg-center bg-no-repeat py-16 md:py-24"
      style={{
        backgroundImage: "url('/images/home/obz-bg-2.png')",
      }}
    >
      <div className="mx-auto px-8 md:px-0 w-[88%] lg:w-[80%]">
        {/* Footer Links */}
        <div className="flex flex-col md:flex-row md:justify-between md:items-start gap-12 md:gap-16">
          {/* Logo Section */}
          <div className="flex flex-col items-start md:w-[25%]">
            {/* Logo */}
            <a href="/" className="flex items-center mb-8 md:mb-10 group">
              <img
                src="/white_logo.png"
                alt="OBZ"
                className="h-[45px] md:h-[55px] w-auto transition-transform duration-200 group-hover:scale-105"
              />
            </a>

            {/* Company Description */}
            <p className="text-[#FFF] opacity-80 RoobertRegular text-[14px] md:text-[16px] leading-[140%] tracking-[-0.35px] max-w-[280px]">
              Building the future of work with AI-powered solutions and human
              expertise.
            </p>
          </div>

          {/* Outcomes We Deliver */}
          <div className="md:w-[18%]">
            <Box
              title={"Outcomes We Deliver"}
              dataList={[
                { text: "Agentic Enterprise", link: "/agentic-experience" },
                { text: "Customer Experience", link: "/customer-experience" },
                { text: "Revenue Growth", link: "/revenue-growth" },
                { text: "Operational Efficiency", link: "/operational-cost" },
              ]}
            />
          </div>

          {/* <div className="md:w-[18%]">
            <Box
              title={"How We Work"}
              dataList={[
                { text: "Our Operating Model", link: "/kuwago" },
                { text: "Human + Digital/AI Delivery", link: "/chattr" },
                { text: "Embedded + Co-Development Approach", link: "/hoots" },
                { text: "OBZ Studio & Reusable Agent Library", link: "/perch" },
                { text: "Strategic Engagement", link: "/pique" },
                { text: "Speed, Quality, and Scale", link: "/pique" },
                { text: "Commercial Models & Code Sharing", link: "/pique" },
              ]}
            />
          </div> */}

          <div className="md:w-[18%]">
            <Box
              title={"About"}
              dataList={[
                { text: "Who We Are", link: "/story" },
              ]}
            />
          </div>

          <div className="md:w-[18%]">
            <Box
              title={"Contact"}
              dataList={[
                { text: "Email", link: "mailto:connect@onebyzero.ai", target: "_blank" },
                {
                  text: "LinkedIn",
                  target: "_blank",
                  link: "https://www.linkedin.com/company/1bz/?viewAsMember=true",
                },
              ]}
            />
          </div>
        </div>

        {/* Divider */}
        <div className="w-full h-px bg-white opacity-20 my-12 md:my-16"></div>

        {/* Copyright */}
        <div className="flex flex-col md:flex-row  md:items-center gap-4 justify-center">
          <div className="text-white  opacity-70 text-center md:text-left text-[14px] md:text-[16px] RoobertRegular">
            © 2025 ONEBYZERO. All rights reserved.
          </div>

          {/* Additional Links */}
          {/* <div className="flex flex-wrap justify-center md:justify-end gap-6 text-[14px] md:text-[16px]">
            <a href="/privacy" className="text-white opacity-70 hover:opacity-100 transition-opacity duration-200 RoobertRegular">
              Privacy Policy
            </a>
            <a href="/terms" className="text-white opacity-70 hover:opacity-100 transition-opacity duration-200 RoobertRegular">
              Terms of Service
            </a>
            <a href="/cookies" className="text-white opacity-70 hover:opacity-100 transition-opacity duration-200 RoobertRegular">
              Cookie Policy
            </a>
          </div> */}
        </div>
      </div>
    </div>
  );
}

export default NewFooter;
